import React, { useEffect, useState } from "react";
import { Container, Grid, Message, Form } from "semantic-ui-react";
import { RolOptionsInvitations } from "./UserModal";
import { useAuth } from "../../../AuthenticationStore";
import { useForm } from "react-hook-form";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { proccessError } from "../../../components/utils/utils";
import moment from "moment";
import { ToastProvider } from "react-toast-notifications";
import { NotificationPopPup } from "../campaigns/New";

export const Invitations = () => {
  const { platformUserService } = useAuth();
  const {
    handleSubmit,
    register,
    errors,
    setValue,
    triggerValidation
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorsApi, setErrorsApi] = useState([]);
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState("");

  const msjToast = "Invitacion enviada con exito";
  const [showToast, setShowToast] = useState(false);

  const columns = [
    {
      Header: "Correo electrónico",
      accessor: "email"
    },
    {
      Header: "Fecha",
      accessor: d => {
        if (!d.generatedDate) return "0000-00-00 00:00";
        return moment(d.generatedDate).format("Y-MM-DD hh:mm");
      },
      id: "generatedDate"
    },
    {
      Header: "Rol",
      accessor: d => {
        switch (d.userRole) {
          case 1:
            return "CTO";
          case 2:
            return "CEO";
          case 3:
            return "CMO";
          default:
            return "Sin estado";
        }
      },
      id: "userRole",
      minWidth: 20
    },
    {
      Header: "Estado",
      accessor: d => {
        switch (d.statusInvitation) {
          case 0:
            return "Activa";
          case 1:
            return "Cancelada";
          case 2:
            return "Aprobada";
          case 3:
            return "Declinada";
          default:
            return "Sin estado";
        }
      },
      id: "statusInvitation",
      minWidth: 35
    },
    {
      Cell: props => (
        <div className="btn-group" role="group" aria-label="">
          <button
            className="btn btn-primary"
            onClick={() => updatedInvitation(props.original)}
          >
            <i className="mdi mdi-reload"></i>
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => cancelInvitation(props.original)}
          >
            <i className="mdi mdi mdi-cancel"></i>
          </button>
        </div>
      ),
      Header: "Acciones",
      accessor: "invitationId",
      minWidth: 50
    }
  ];

  useEffect(() => {
    register({ name: "userRole" }, { required: true });
    register(
      { name: "email" },
      {
        pattern: {
          message: "Correo electrónico no valido",
          value: /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
        },
        required: true
      }
    );

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const invitations = await platformUserService.getInvitations();
      const arrayErrors = proccessError(invitations);
      setErrorsApi(arrayErrors);
      setData(invitations.object);
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
    setLoading(false);
  };

  const onSubmit = async values => {
    try {
      const invitations = await platformUserService.createInvitation(
        values.email,
        values.userRole
      );
      // eslint-disable-next-line no-console
      const arrayErrors = proccessError(invitations);
      setErrorsApi(arrayErrors);
      // if not errors reload table invitations
      if (arrayErrors.length === 0) {
        clearForm();
        fetchData();
      }
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
  };

  const updatedInvitation = async invitation => {
    try {
      const response = await platformUserService.updateInvitation(
        invitation.invitationId
      );
      // eslint-disable-next-line no-console
      const arrayErrors = proccessError(response);
      setErrorsApi(arrayErrors);
      // if not errors reload table invitations
      if (arrayErrors.length === 0) fetchData();
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
  };

  const cancelInvitation = async invitation => {
    try {
      const response = await platformUserService.cancelInvitation(
        invitation.invitationId
      );
      // eslint-disable-next-line no-console
      const arrayErrors = proccessError(response);
      setErrorsApi(arrayErrors);
      // if not errors reload table invitations
      if (arrayErrors.length === 0) fetchData();
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
  };

  const clearForm = () => {
    setUserRole("");
    setEmail("");
    setValue("email", "");
    setValue("userRole", "");
    setShowToast(true);
    setShowToast(false);
  };

  return (
    <Container>
      <ToastProvider>
        <NotificationPopPup showToast={showToast} text={msjToast} />
      </ToastProvider>
      {errorsApi.length > 0 ? (
        <Message error>
          <Message.Header>Errores</Message.Header>
          <Message.List items={errorsApi} />
        </Message>
      ) : null}
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group widths="equal" style={{ alignItems: "flex-end" }}>
                <Form.Select
                  error={!!errors.userRole}
                  name="userRole"
                  fluid
                  value={userRole}
                  options={RolOptionsInvitations}
                  label="Rol"
                  placeholder="Rol"
                  onChange={async (e, { name, value }) => {
                    setValue(name, value);
                    setUserRole(value);
                    await triggerValidation(name);
                  }}
                />
                <Form.Input
                  error={!!errors.email}
                  fluid
                  value={email}
                  label="Correo electrónico"
                  name="email"
                  placeholder="Correo electrónico"
                  onChange={async (e, { name, value }) => {
                    setValue(name, value);
                    setEmail(value);
                    await triggerValidation({ name });
                  }}
                />
                <button
                  className="btn btn-primary btn-icon-text"
                  style={{ height: "45px", width: "250px" }}
                  type="submit"
                >
                  <i className="mdi mdi-content-save"></i> Enviar
                </button>
              </Form.Group>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              manual
              defaultPageSize={10}
              data={data}
              onFetchData={fetchData}
              loading={loading}
              minRows={1}
              columns={columns}
              previousText="Anterior"
              nextText="Siguiente"
              pageText="página"
              ofText="de"
              rowsText="registros"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};
